import React, { useState, useCallback, useMemo, useContext } from 'react';
import useEmploymentTypes from '@ubeya/shared/hooks/generic/useEmploymentTypes';
import DropDown from '../../DropDown';
import CheckBox from '../../CheckBox';
import FilterLayout from '../FilterLayout';
import ConfigContext from '../../../contexts/ConfigContext';

const EmploymentTypeFilter = ({ defaultValue, handleClose, onApply, search, onChange, hideLayout = false }) => {
  const { t } = useContext(ConfigContext);
  const { employmentTypesOptions } = useEmploymentTypes();

  const [values, setValues] = useState(defaultValue || []);

  const handleChange = useCallback(
    (value) => {
      const newValues = values.includes(value) ? values.filter((item) => item !== value) : [...values, value];
      setValues(newValues);
      onChange?.(newValues);
    },
    [onChange, values]
  );

  const filteredOptions = useMemo(
    () =>
      search
        ? employmentTypesOptions.filter(
            ({ label }) =>
              t('employmentTypes').toLowerCase().includes(search.toLowerCase()) ||
              (label && label.toLowerCase().includes(search.toLowerCase()))
          )
        : employmentTypesOptions,
    [employmentTypesOptions, search, t]
  );

  if (!filteredOptions.length) {
    return null;
  }

  return (
    <FilterLayout
      name={t('employmentTypes')}
      handleClose={handleClose}
      onApply={() => onApply(values)}
      hideLayout={hideLayout}>
      {filteredOptions.map(({ value, label }) => (
        <DropDown.Item key={value}>
          <CheckBox
            useTextWithTooltip
            name={`employmentType-${value}`}
            value={values.includes(value)}
            label={label}
            onChange={() => handleChange(value)}
          />
        </DropDown.Item>
      ))}
    </FilterLayout>
  );
};

export default EmploymentTypeFilter;
